import React, {useEffect} from "react";
import EventType from "./event-type.jsx";
import Cards from "./cards.jsx";
import EventLocal from "./event-local.jsx";
import AddressWithMostEvents from "./address-with-most-events.jsx";
import EventNeighborhood from "./event-neighborhood.jsx";
import EventByWeekDay from "./event-by-week-day.jsx";
import EventByAgent from "./event-by-agent.jsx";
import reportUtils from "../../../../../utils/report-utils.js";


const ReportContent = ({data}) => {
    const labels = [
        "ID",
        "Nome do evento",
        "Data do evento",
        "Dia da semana",
        "Status",
        "Tempo médio de encerramento",
        "Nome de usuário",
        "Tipo de local",
        "Local",
        "Endereço"
    ]

    const values = data.eventsList.map(item => Object.values(item))

    return(
        <>
            <Cards data={data.eventsCards} values={values} labels={labels}/>
            
            <EventType data={data}/>
            
            <EventLocal data={data}/>
            
            <AddressWithMostEvents data={data} />
            
            <EventNeighborhood data={data} />
            
            <EventByWeekDay data={data?.eventsByWeekday}/>
            
            <EventByAgent data={data} />

            <div id="chart-tables"></div>
        </>
    )
}

export default ReportContent;